// extracted by mini-css-extract-plugin
export default {"root":"IconUser_root__y74tu","fillColor":"IconUser_fillColor__HQ-CS"};